import UtilitiesController from './utilitiesController';

export default class ThreadController {

  static exceptionWrapper = (fn) => async (data) => {
    try {
      return await fn(data).catch((err) => {
        throw err;
      });
    } catch (err) {
      return {
        success: false,
        error: err.message
      };
    }
  };

  static getThreadConsultations = ThreadController.exceptionWrapper(async (data) => {
    return await UtilitiesController.post('/v5/api/threads/get/consultations', data, true);
  });

  static getThreadMessages = ThreadController.exceptionWrapper(async (data) => {
    return await UtilitiesController.post('/v5/api/threads/get/messages', data, true);
  });

  static sendThreadMessage = ThreadController.exceptionWrapper(async (data) => {
    return await UtilitiesController.post('/v5/api/threads/new/message', data, true);
  });

  static getThreadConsultationByCode = ThreadController.exceptionWrapper(async (code) => {
    let normalized_code = code ? code.toUpperCase() : '';
    return await UtilitiesController.get(`/v5/api/threads/consultation/${normalized_code}`, {}, true);
  });

  static initiateThreadWaitlistMsgs = ThreadController.exceptionWrapper(async (data) => {
    return await UtilitiesController.post('/v5/api/threads/initiate_thread_waitlist_msgs', data, true);
  });
}
